import React, { useState } from 'react';
import { productHistoryData, productlistdata } from '../../../Data/Dummydata';
import Card from '../../../Components/Ui/Card';
import { ChevronDown, ChevronUp } from 'lucide-react';

const HistoryPage = () => {
  const [openProductIds, setOpenProductIds] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All Categories');

  const uniqueCategories = [
    'All Categories',
    ...Array.from(new Set(productlistdata.map((p) => p.category))),
  ];

  const groupedHistory = productHistoryData.reduce((acc, entry) => {
    if (!acc[entry.productId]) acc[entry.productId] = [];
    acc[entry.productId].push(entry);
    return acc;
  }, {});

  const toggleAccordion = (productId) => {
    setOpenProductIds((prev) =>
      prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId],
    );
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between justify-center items-center">
        <h2 className="text-lg xl:text-2xl font-bold mb-4 pl-5">Product History</h2>

        <div className="mb-3 flex items-center gap-3">
          <select
            id="categoryFilter"
            value={selectedCategory}
            onChange={(e) => {
              setSelectedCategory(e.target.value);
            }}
            className="border py-2 border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 border-color "
          >
            {uniqueCategories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>
      </div>

      {Object.keys(groupedHistory).length === 0 ? (
        <Card className="p-6 text-center">
          <p className="text-gray-500">No product modification history found.</p>
        </Card>
      ) : (
        <div className="space-y-4">
          {Object.entries(groupedHistory).map(([productId, entries]) => {
            const product = productlistdata.find((item) => String(item.id) === productId);

            if (
              !product ||
              (selectedCategory !== 'All Categories' && product.category !== selectedCategory)
            ) {
              return null;
            }

            const isOpen = openProductIds.includes(productId);

            return (
              <div key={productId} className="border rounded-xl">
                <button
                  onClick={() => toggleAccordion(productId)}
                  className="w-full flex justify-between items-center px-6 py-4 text-left bg-indigo-50 hover:bg-indigo-100 transition-colors rounded-t-xl"
                >
                  <div>
                    <h3 className="text-sm xl:text-lg font-semibold primary-color">
                      {product?.productName || 'Unknown Product'}
                    </h3>
                    <p className="text-sm text-gray-500">
                      Category: {product.category} | ID: {productId}
                    </p>
                  </div>
                  {isOpen ? (
                    <ChevronUp className="primary-color" />
                  ) : (
                    <ChevronDown className="primary-color" />
                  )}
                </button>

                {isOpen && (
                  <div className="space-y-6 px-6 pb-6 pt-2">
                    {entries
                      .sort((a, b) => new Date(b.date) - new Date(a.date))
                      .map((entry, index) => (
                        <Card key={index} className="p-5 rounded-xl shadow-sm">
                          <div className="flex justify-between items-center mb-2">
                            <span className="text-sm font-semibold text-secondary">
                              {new Date(entry.date).toLocaleDateString()}
                            </span>
                            <span className="text-sm text-gray-500">
                              Modified by: {entry.modifiedBy}
                            </span>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mt-2">
                            {entry.changes.map((change, i) => (
                              <div key={i} className="bg-gray-50 p-4 border rounded-lg">
                                <p className="font-medium text-secondary mb-1">{change.field}</p>
                                <p className="text-red-600">
                                  Before: <span className="line-through">{change.before}</span>
                                </p>
                                <p className="text-green-600">After: {change.after}</p>
                              </div>
                            ))}
                          </div>

                          {entry.note && (
                            <p className="mt-4 text-sm italic text-gray-600">
                              💬 Note: {entry.note}
                            </p>
                          )}
                        </Card>
                      ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default HistoryPage;
